"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.purple7 = exports.purple6 = exports.purple5 = exports.purple4 = exports.purple3 = exports.purple2 = exports.green2 = exports.green1 = exports.blue5 = exports.blue4 = exports.blue3 = exports.gray8 = exports.gray7 = exports.gray6 = exports.gray5 = exports.gray4 = exports.blank_30 = exports.colorOnBackgroundBrand = exports.backgroundBrand = exports.colorOnBackgroundDashboard = exports.backgroundDashboard = exports.colorOnBrandPrimary = exports.brandSecondary = exports.brandPrimaryTransparentized = exports.brandPrimary = void 0;

var _foundations = require("@remote-com/norma/foundations");

var _polished = require("polished");

var brandPrimary = _foundations.theme.colors.irisBlue;
exports.brandPrimary = brandPrimary;
var brandPrimaryTransparentized = 'rgba(98, 77, 227, 0.08)';
exports.brandPrimaryTransparentized = brandPrimaryTransparentized;
var brandSecondary = _foundations.theme.colors.darkTurquoise;
exports.brandSecondary = brandSecondary;
var colorOnBrandPrimary = _foundations.theme.colors.blank;
exports.colorOnBrandPrimary = colorOnBrandPrimary;
var backgroundDashboard = _foundations.theme.colors.linkWater;
exports.backgroundDashboard = backgroundDashboard;
var colorOnBackgroundDashboard = _foundations.theme.colors.darkBlue;
exports.colorOnBackgroundDashboard = colorOnBackgroundDashboard;
var backgroundBrand = brandPrimary;
exports.backgroundBrand = backgroundBrand;
var colorOnBackgroundBrand = _foundations.theme.colors.blank; // eslint-disable-next-line

exports.colorOnBackgroundBrand = colorOnBackgroundBrand;
var blank_30 = (0, _polished.transparentize)(0.7, _foundations.theme.colors.blank); // Stale colors - DO NOT USE. Please, make an effort to replace them.

/**
 * @deprecated use use @remote-com/norma/foundations instead.
 */

exports.blank_30 = blank_30;
var gray4 = '#F9FAFF';
/**
 * @deprecated use use @remote-com/norma/foundations instead.
 */

exports.gray4 = gray4;
var gray5 = _foundations.theme.colors.geyser;
/**
 * @deprecated use use @remote-com/norma/foundations instead.
 */

exports.gray5 = gray5;
var gray6 = '#F2F5FA';
/**
 * @deprecated use use @remote-com/norma/foundations instead.
 */

exports.gray6 = gray6;
var gray7 = '#EAEDF3';
/**
 * @deprecated use use @remote-com/norma/foundations instead.
 */

exports.gray7 = gray7;
var gray8 = '#F5F6F8';
/**
 * @deprecated use use @remote-com/norma/foundations instead.
 */

exports.gray8 = gray8;
var blue3 = '#f5f9fe';
/**
 * @deprecated use use @remote-com/norma/foundations instead.
 */

exports.blue3 = blue3;
var blue4 = '#D6E6FD';
/**
 * @deprecated use use @remote-com/norma/foundations instead.
 */

exports.blue4 = blue4;
var blue5 = '#EAF1FF';
/**
 * @deprecated use use @remote-com/norma/foundations instead.
 */

exports.blue5 = blue5;
var green1 = '#f3fafb';
/**
 * @deprecated use use @remote-com/norma/foundations instead.
 */

exports.green1 = green1;
var green2 = '#0097A0';
/**
 * @deprecated use use @remote-com/norma/foundations instead.
 */

exports.green2 = green2;
var purple2 = '#b0a6f1';
/**
 * @deprecated use use @remote-com/norma/foundations instead.
 */

exports.purple2 = purple2;
var purple3 = '#806ee6';
/**
 * @deprecated use use @remote-com/norma/foundations instead.
 */

exports.purple3 = purple3;
var purple4 = '#5849D4';
/**
 * @deprecated use use @remote-com/norma/foundations instead.
 */

exports.purple4 = purple4;
var purple5 = '#7260e2';
/**
 * @deprecated use use @remote-com/norma/foundations instead.
 */

exports.purple5 = purple5;
var purple6 = '#E2E7FF';
/**
 * @deprecated use use @remote-com/norma/foundations instead.
 */

exports.purple6 = purple6;
var purple7 = '#D8D2F8';
exports.purple7 = purple7;